import Select from "react-select";
import AlertContext from "../../context/AlertContext";
import React, { useContext, useEffect, useRef, useState } from "react";
import AngleLeftSvg from "../../Svg/AngleLeftSvg";
import AngleRightSvg from "../../Svg/AngleRightSvg";
import CodingViewHooks from "../../Hooks/CodingPage/CodingViewHooks";
import StudentTestAdminHooks from "../../Hooks/StudentTestPage/StudentTestAdminHooks";
import StudentListHooks from "../../Hooks/StudentListHooks";
import BreadCrumbsHooks from "../../Hooks/BreadCrumbsHooks";
import constants from "../../constants";
import MockTestLibraryHooks from "../../Hooks/Mock/Student/MockTestLibraryHooks";
import { useNavigate } from "react-router-dom";
import MockTestResultsHooks from "../../Hooks/Mock/Student/MockTestResultsHooks";

const MockChapterDetails = () => {
  const {
    mockTestReportTopic,
    setMockTestReportTopic,
    mockTestReportCurrentTopic,
    setMockTestReportCurrentTopic,
    showBreadCrumbsData,
    isAdmin,
    setShowNotify,
    setShowBreadCrumbsData,
  } = useContext(AlertContext);
  const { getStudentList } = StudentListHooks();
  const { handleMcq } = StudentTestAdminHooks();
  const MockTestResultsHks = MockTestResultsHooks();

  const { viewCode } = CodingViewHooks();
  const { getCurrentPageDetails, getCurrentQuestionIdForCurrentLearner } =
    BreadCrumbsHooks();
  const MockTestLibraryHks = MockTestLibraryHooks();
  const navigate = useNavigate();
  const selectedTopic = useRef(null);

  const [currentTopic, setCurrentTopic] = useState("");
  const [showPrevButton, setShowPrevButton] = useState(false);
  const [showNextButton, setShowNextButton] = useState(false);

  const customStyle = {
    control: (provided) => ({
      ...provided,
      minWidth: 150,
      maxWidth: 200,
      outline: "none",
      cursor: "pointer",
      boxShadow: "none",
      border: "0px solid white",
      backgroundColor: "#fafafa",
    }),
    option: (styles, { isDisabled, isFocused, data }) => {
      return {
        ...styles,
        fontSize: "12px",
        textAlign: "left",
        cursor: "pointer",
        padding: "2px 12px",
        color:
          data.status === 10
            ? "#027A48"
            : data.status === 11 || data.status === 12
            ? "#FDB022"
            : data.status === 13
            ? "#E54B2A"
            : data.status === 14
            ? "#B42318"
            : data.status === 15
            ? "#175CD3"
            : data.status === 16
            ? "#344054"
            : isDisabled
            ? "#grey"
            : "black",
        backgroundColor:
          data.status === 10
            ? "#ECFDF3"
            : data.status === 11 || data.status === 12
            ? "#FFFAEB"
            : data.status === 13
            ? "#FCEBE8"
            : data.status === 14
            ? "#FEF3F2"
            : data.status === 15
            ? "#EFF8FF"
            : data.status === 16
            ? "#F2F4F7"
            : "white",
      };
    },
  };

  useEffect(() => {
    selectedTopic.current = mockTestReportCurrentTopic;
  }, []);

  const handleChangeTopic = (action) => {
    if (action === "prev") {
      let previousOne = mockTestReportTopic.find(
        (topic) => topic.value === mockTestReportCurrentTopic.value - 1,
      );
      setMockTestReportCurrentTopic(previousOne);
      handleChange(previousOne);
    } else if (action === "next") {
      let nextOne = mockTestReportTopic.find(
        (topic) => topic.value === mockTestReportCurrentTopic.value + 1,
      );
      setMockTestReportCurrentTopic(nextOne);
      handleChange(nextOne);
    }
  };

  const mockTopicLoad = (e) => {
    setMockTestReportCurrentTopic(e);
    handleChange(e);
  };

  const handleChange = (currentNode) => {
    console.log("currentNode:", currentNode);

    let { row, col, batchid } = currentNode;
    let showBreadCrumbsData = currentNode;

    console.log("row;", row, "col:", col, "batchId:", batchid);

    const reqColumns = Object.keys(row).filter((r) =>
      r.startsWith(currentNode.label),
    );
    const libtypeKey = reqColumns.filter((r) => r.endsWith("_libtype"));
    const libtype = row[libtypeKey];
    const lmtidKey = reqColumns.filter((r) => r.endsWith("lmtid"));
    const lmpidKey = reqColumns.filter((r) => r.endsWith("lmpid"));
    const statusKey = reqColumns.filter((r) => r.endsWith("status"));

    console.log("reqColumns:", reqColumns);

    const lmpid = row[lmpidKey];
    const lmtid = row[lmtidKey];
    const status = row[statusKey];

    if (!lmpid && !lmtid) {
      setShowNotify({
        show: true,
        msg: `You haven't submitted the test yet!. Please submit before the deadline.`,
        title: "Warning !",
      });
      setMockTestReportCurrentTopic(selectedTopic.current);
      return;
    }

    const testid = lmtidKey[0].split("_")[1];
    let tname = lmtidKey[0].split("_")[0];
    if (isAdmin || showBreadCrumbsData.from === "learner") {
      if (libtype === constants.libTypeIds.ASSIGNMENT) {
        console.log("1st 1st");
        if (
          [
            constants.QUESTION_STATUS.SUBMITTED,
            constants.QUESTION_STATUS.TO_BE_EVALUATED,
          ].includes(status) ||
          isAdmin
        )
          getCurrentPageDetails(showBreadCrumbsData);
        else {
          setShowNotify({
            show: true,
            msg: `You haven't submitted the ${
              showBreadCrumbsData.type === constants.libTypeIds.ASSIGNMENT
                ? "assignment"
                : "question"
            } yet!. Please submit before the deadline.`,
            title: "Warning !",
          });
          return;
        }
      } else if (libtype === constants.libTypeIds.CODING_CHALLENGE) {
        console.log("status:", status);

        if (
          [
            constants.PROGRESS_STATUS.EVALUATED,
            constants.PROGRESS_STATUS.TO_BE_EVALUATED,
          ].includes(status)
        ) {
          navigate(`/batches/${batchid}/dashboard/config`);
          const testData = {
            id: testid,
            name: tname,
            mode: 2,
            videoqn: 0,
            libtype: constants.libTypeIds.CODING_CHALLENGE,
            viewtest: 1,
            learnerid: row.learnerid,
            lmtid: lmtid,
            lmpid: lmpid,
          };
          console.log("testData:", testData);

          MockTestLibraryHks.handleTest(testData);
        }
      } else {
        console.log("1st 2nd");

        // getStudentList(showBreadCrumbsData);
        // console.log("showBreadCrumbsData", showBreadCrumbsData);
        if (
          [
            constants.PROGRESS_STATUS.EVALUATED,
            constants.PROGRESS_STATUS.TO_BE_EVALUATED,
          ].includes(status) ||
          isAdmin
        ) {
          const testData = {
            id: testid,
            name:tname,
            mode: 2,
            videoqn: 0,
            status: status,
            withAI: 0,
            libtype: libtype,
            testtype: libtype,
            viewtest: 1,
            learnerid: row.learnerid,
            lmtid: lmtid,
            lmpid: lmpid,
            //   duration: test.testduration,
            //   questionscount: test.questionscount,
            // marks: data.split("/")[0],
          };

          MockTestResultsHks.handleView(testData);
        } else {
          setShowNotify({
            show: true,
            msg: `You haven't submitted the test yet!. Please submit before the deadline.`,
            title: "Warning !",
          });
          return;
        }
      }
    } else {
      console.log("2nd");

      viewCode(
        showBreadCrumbsData.test,
        "single",
        showBreadCrumbsData.questions,
      );
    }
    // setShowBreadCrumbsData(showBreadCrumbsData);
  };

  console.log(
    "mockTestReportTopic:",
    mockTestReportTopic,
    "mockTestReportCurrentTopic:",
    mockTestReportCurrentTopic,
  );

  useEffect(() => {
    if (mockTestReportCurrentTopic?.value == 0) {
      setShowPrevButton(true);
    } else if (
      mockTestReportCurrentTopic?.value ==
      mockTestReportTopic.length - 1
    ) {
      setShowNextButton(true);
    } else {
      setShowNextButton(false);
      setShowPrevButton(false);
    }
  }, [mockTestReportCurrentTopic]);

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <AngleLeftSvg
        disabled={showPrevButton}
        handleFunction={() => handleChangeTopic("prev")}
      />
      <Select
        isClearable={false}
        styles={customStyle}
        onChange={mockTopicLoad}
        options={mockTestReportTopic}
        value={mockTestReportCurrentTopic}
        className="codeEditorLanguageSelectorAdmin"
        // isOptionDisabled={(option) => option.isdisabled}
        components={{
          IndicatorSeparator: () => null,
        }}
      />
      <AngleRightSvg
        disabled={showNextButton}
        handleFunction={() => handleChangeTopic("next")}
      />
      <div title={"Question " + showBreadCrumbsData.questionNo}>
        Question {showBreadCrumbsData.questionNo}
      </div>
    </div>
  );
};

export default MockChapterDetails;
